import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useCallback,
} from 'react';
import {ChatMessage, Contact} from '../../types/Contact';
import {UserInfo} from '../../types/UserInfo';
import {
  View,
  TouchableOpacity,
  Platform,
  useWindowDimensions,
  ViewStyle,
} from 'react-native';

import {UserCtx} from '../../ctx';

import {useMessages} from '../../hooks/useMessages';
import {
  ActivityIndicator,
  AnimatedFAB,
  List,
  ProgressBar,
  useTheme,
} from 'react-native-paper';

import {
  Bubble,
  BubbleProps,
  Composer,
  GiftedAvatar,
  GiftedChat,
} from 'react-native-gifted-chat';
import {textAccentColor} from './styles';
import {Auction, EditorComment} from '../../types';
import {ChatInputToolbar} from './components/toolbar';
import {ChatBubble} from './components/bubble';
import {useChatWebRefresh} from '../../hooks/useChatWebRefresh';
import {useAppSelector} from '../../store/hooks';
import {ChatParams} from '../../types/nav';
export interface ChatViewParams {
  chatId: string;
  params: {
    contact: Contact | Auction | EditorComment;
    user: UserInfo;
  };
  queryParams: ChatParams;
  isEmbeded?: boolean;
  height?: number;
}

const ChatView = (chatViewParams: ChatViewParams) => {
  const {
    chatId,
    params,
    height: propsHeight,
    isEmbeded,
    queryParams,
  } = chatViewParams;

  const {user} = params;
  const {messages, sendMessage, nextPage, isLoadingEarlier} =
    useMessages(chatId, queryParams);

  const onSend = (text: string) => sendMessage(text);

  const current = useContext(UserCtx);

  const theme = useTheme();
  const keyheight = useAppSelector(state =>
    isEmbeded ? 0 : state.ui.keyboardHeight,
  );
  const {colors} = theme;
  useChatWebRefresh();
  let platformOffset = Platform.OS === 'ios' ? 110 : 60;
  // const
  if (Platform.OS === 'web') platformOffset = 50;

  // if (isNotParticipating)
  //   platformOffset = Platform.select({
  //     ios: 70,
  //     android: 20,
  //     web: 10,
  //     macos: 0,
  //     windows: 0,
  //     native: 0,
  //   })

  //CALCULATED BASED ON THE HEIGHT OF THE VIEWPORT, KEYBOARD HEIGHT AND INPUT HEIGHT
  const {height: windowHeight, width: windowWidth} =
    useWindowDimensions();
  const height = propsHeight ? propsHeight : windowHeight;
  const messagesContainerHeight = height - platformOffset - keyheight;
  let dynamicHeight = messagesContainerHeight;
  const isUploadInProgress = useAppSelector(
    state => state.upload.isUploadInProgress,
  );
  const hasMedia = useAppSelector(
    state => state.media.currentMediaId,
  );
  const isMobile = windowWidth < 700;
  if (isUploadInProgress) dynamicHeight -= 50;

  if (hasMedia) dynamicHeight -= isMobile ? height / 4 : height / 2;
  const fullMessageContainerStyle = {
    ...messagesContainerStyles,
    height: dynamicHeight,
    borderColor: colors.background,
  };
  const preloaderStyle =
    Platform.OS === 'android' ? {} : {transform: [{scaleY: -1}]};
  console.info('chatviewreload');
  return (
    <View
      style={{
        backgroundColor: current!.colors.backgroundColor,
        height: dynamicHeight,
        width: '100%',
        flexDirection: 'row',
      }}>
      <GiftedChat
        scrollToBottom={true}
        renderLoading={() => <ActivityIndicator size={72} />}
        messages={messages.map((m: ChatMessage) => {
          // console.info("messages", m)
          return {
            ...m,
            _id: m.id,
            user: {
              _id: m.userId,
              name: m.userName,
            },
          };
        })}
        onSend={([message]) => onSend(message.text)}
        user={{
          _id: user?.id,
          avatar: user?.photo,
        }}
        renderBubble={bubbleProps => (
          <ChatBubble
            {...{
              ...(bubbleProps as Readonly<BubbleProps<ChatMessage>>),
              bgColor: '#344868',
              chatId,
            }}
          />
        )}
        timeTextStyle={{}}
        renderAvatar={props => <></>}
        listViewProps={{
          scrollEventThrottle: 400,
          // onEndReached: () => {
          //   console.info('on end of chat reached', isLoadingEarlier);
          //   if (isLoadingEarlier === true) return;
          //   nextPage();
          // },
        }}
        showUserAvatar={false}
        showAvatarForEveryMessage
        isKeyboardInternallyHandled={false}
        messagesContainerStyle={fullMessageContainerStyle}
        // isLoadingEarlier={isLoadingEarlier}
        // loadEarlier={false}
        // onLoadEarlier={() => nextPage()}
        // renderLoadEarlier={props => (
        //   <View style={{height: 100, width: '100%'}}>
        //     {props.isLoadingEarlier ? (
        //       <ActivityIndicator size={32} />
        //     ) : (
        //       <View style={{height: 100}} />
        //     )}
        //   </View>
        // )}
        renderChatEmpty={() => (
          <View style={preloaderStyle}>
            <List.Item
              left={p => (
                <List.Icon
                  {...p}
                  color={textAccentColor}
                  icon={'lock'}
                />
              )}
              titleStyle={{color: textAccentColor}}
              title={'Decrypting Messages...'}
            />
            <ProgressBar indeterminate visible={true} />
          </View>
        )}
        scrollToBottomComponent={() => (
          <AnimatedFAB
            icon={'arrow-down'}
            label="⠀"
            visible
            iconMode={'static'}
            extended={false}
          />
        )}
        // forceGetKeyboardHeight={true}
        scrollToBottomStyle={scrollToBottomStyle}
        renderInputToolbar={inputProps => (
          <ChatInputToolbar
            chatId={chatId}
            inputProps={inputProps}
            isEmbed={isEmbeded}
            dynamicHeight={dynamicHeight}
          />
        )}
        placeholder="Write your message"
      />
    </View>
  );
};

const scrollToBottomStyle: ViewStyle = {
  backgroundColor: 'transparent',
  right: 65,
  bottom: 80,
  opacity: 1,
};

const messagesContainerStyles: ViewStyle = {
  backgroundColor: 'transparent',
  paddingBottom: 100,
  borderBottomWidth: 0,
};

export default ChatView;
